<template>

    <div class="">
        <AdminBlock :title="'Invoice Rows for Job ' + job.reference + ', Purchase Order: ' + purchaseOrderLabel">
            <table class="table table-striped mb-0">
                <tbody>
                    <tr>
                        <td>
                            <strong>
                                Job {{ job.reference }} ({{ job.collection_date }}) ({{ job.status === 'aborted' || job.aborted_at_movement_id !== null ? 'Aborted' : 'Completed' }})
                            </strong>
                            <br>
                            Vehicle
                            <span v-if="job.vehicle">
                                {{ job.vehicle.reg }}
                            </span>
                            <span v-else>
                                <em>Not Set</em>
                            </span>
                            from
                            {{ job.collection_company && job.collection_company.length > 0 ? job.collection_company + ', ' : '' }}{{ job.collection_location }}
                            to
                            {{ job.collection_company && job.delivery_company.length > 0 ? job.delivery_company + ', ' : '' }}{{ job.delivery_location }}
                        </td>
                        <td>
                            <p class="mb-0">&pound;{{ job.price }} + VAT</p>
                        </td>
                        <td></td>
                    </tr>
                    <tr v-for="expense in compExpenses" :key="'expense-' + expense.id">
                        <td>
                            <p class="mb-0">
                                <strong>Expense</strong>
                                {{ expense.label }}
                                <template v-if="expense.reference && expense.reference.length > 0">
                                    ({{ expense.reference }})
                                </template>
                            </p>
                        </td>
                        <td>
                            <p class="mb-0">
                                <template v-if="expense.fuel">
                                    <template v-if="expense.fuel > 0">
                                        {{ expenseCosts[expense.id] ? formatValue(expenseCosts[expense.id].cost) + " + VAT" :  'Calculating...' }}
                                    </template>
                                    <template v-else>
                                        £0.00 + VAT
                                    </template>
                                </template>
                            </p>
                        </td>
                        <td></td>
                    </tr>
                    <tr v-for="line in invoice_lines" :key="'line-' + line.id">
                        <td>
                            <p class="mb-0">
                                <strong>
                                    {{ line.type}}
                                </strong>
                                {{ line.description }}
                            </p>
                        </td>
                        <td >
                            {{
                                Intl.NumberFormat("en-GB", {
                                    style: "currency",
                                    currency: "GBP",
                                    minimumFractionDigits: 2,
                                }).format(line.price_exc_vat)
                            }}
                            <span v-if="line.type !== 'Bridge and Road Tolls'">
                                <span v-if="!line.no_vat">
                                    + VAT
                                </span>
                            </span>
                        </td>
                        <td>
                            <button class="btn btn-danger btn-sm" @click="deleteInvoiceLine(line.id)">
                                Remove
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </AdminBlock>

        <AdminBlock title="Additional Rows">
            <div class="row">
                <div class="col-lg-4">

                    <label for="">
                        <strong>
                            Payment Method
                        </strong>
                    </label>

                    <div class="mb-4">
                        <v-select
                            :options="[
                                { value: 'Waiting Time', label: 'Waiting Time' },
                                { value: 'Weekend Rate', label: 'Weekend Rate' },
                                { value: 'Vehicle Breakdown', label: 'Vehicle Breakdown' },
                                { value: 'Night Out', label: 'Night Out (£32 per night)' },
                                { value: 'AD Blue', label: 'AD Blue' },
                                { value: 'Bridge and Road Tolls', label: 'Bridge and Road Tolls' },
                                { value: 'Misc', label: 'Misc' }
                            ]"
                            placeholder="Payment Method"
                            v-model="selectedPaymentMethod"
                            required
                        />
                    </div>

                    <p>If you want to add one of the following expenses, please do that on the previous step:</p>
                    <div class="row">
                        <div class="col-6">
                            <ul>
                                <li>Bus</li>
                                <li>Car Wash</li>
                                <li>Oil</li>
                            </ul>
                        </div>
                        <div class="col-6">
                            <ul>
                                <li>Storage</li>
                                <li>Taxi</li>
                                <li>Train</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5">
                    <InputTextField
                        name="description"
                        label="Description (Optional)"
                        v-model="invoiceline_description"
                    />
                </div>
                <div class="col-lg-2">
                    <div class="input-group">
                        <InputNumberField
                            name="fuel"
                            label="Price (exc VAT)"
                            placeholder="0.00"
                            prepend="£"
                            v-model="invoiceline_price_exc_vat"
                        />
                        <label for="no_vat">
                            <input type="checkbox" name="no_vat" id="no_vat" v-model="no_vat" />
                            <strong>
                                Do not add VAT
                            </strong>
                        </label>
                    </div>
                </div>
                <div class="col-lg-1">
                    <input
                        type="submit"
                        class="btn btn-primary"
                        style="margin-top:23px;"
                        value="Add"
                        @click="addInvoiceLine()"
                    />
                </div>
            </div>
        </AdminBlock>

        <AdminBlock>
            <div class="d-flex justify-content-end gap-2">
                <div class="">
                    <a class="btn btn-sm btn-danger" :href="generateBackUrl()">
                        Back
                    </a>
                </div>
                <div class="">
                    <a class="btn btn-sm btn-secondary" :href="generateBackToJobsListUrl()">
                        Back to Jobs List
                    </a>
                </div>
                <div class="">
                    <button class="btn btn-sm btn-success" @click="submitSignoff()">
                        Set Ready to Invoice
                    </button>
                </div>
            </div>
        </AdminBlock>

    </div>

</template>

<script>

import axios from "axios";
import VSelect from 'vue-select';
import AdminBlock from '@/components/movements/components/AdminBlock.vue';
import InputTextField from '@/components/movements/components/InputTextField.vue';
import InputNumberField from "@/components/movements/components/InputNumberField.vue";
import { usePoActions } from "@/composables/usePoActions";

export default {

        components: {
            InputNumberField,
            InputTextField,
            AdminBlock,
            VSelect,
        },

        props: {
            job: {
                type: Object,
                required: true,
            },
            movements: {
                type: Array,
                required: true,
            },
            hasExpenses: {
                type: Boolean,
                required: true,
            },
            po: {
                type: Object,
                default: () => null,
                required: false,
            },
        },

        setup() {
            // The third screen to share these confirmations, after the PO
            // Manager and the invoice wizard. The invoice-without-a-PO wording
            // especially is lifted rather than rewritten: it is the one an
            // operator acts on irreversibly, and three screens wording it three
            // ways is three chances to describe it wrongly.
            return usePoActions();
        },

        methods: {

            generateBackUrl() {
                return route('movements.jobs.signoff.expenses', { job: this.job.id });
            },

            generateBackToJobsListUrl() {
                return route('movements.jobs.index', { filter: 'ready-to-invoice' });
            },

            poManagerUrl() {
                return route('movements.po.index');
            },

            /**
             * A full reload rather than patching the notice in place: the job's
             * reminder count, its cool-down and — after an invoice goes out
             * without one — its purchase order and status all change, and
             * every one of them was
             * rendered into this page by the server.
             */
            chase() {
                this.confirmThenProcess(this.po.action, () => window.location.reload());
            },

            submitSignoff() {

                axios.post( route('api.movements.jobs.ready-to-invoice.complete', { job: this.job.id }) )
                    .then( response => {
                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            icon: 'success',
                            title: 'Job set Ready to Invoice',
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true
                        }).then(() => {
                            window.location.href = route('movements.jobs.index');
                        });
                    })
                    .catch( error => {
                        console.error(error);
                    });

            },

            formatValue(value) {
                if (value === null || Number.isNaN(value)) {
                    return "";
                }

                return Intl.NumberFormat("en-GB", {
                    style: "currency",
                    currency: "GBP",
                    minimumFractionDigits: 2,
                }).format(value);
            },

            addInvoiceLine() {

                if ( this.selectedPaymentMethod === '' ) {
                    Swal.fire({
                        toast: true,
                        position: 'top-end',
                        icon: 'error',
                        title: 'Please select a payment method',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    return;
                }

                if ( this.invoiceline_price_exc_vat === '' ) {
                    Swal.fire({
                        toast: true,
                        position: 'top-end',
                        icon: 'error',
                        title: 'Please enter a price',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    return;
                }

                const data = new FormData();

                data.append('job_id', this.job.id);
                data.append('description', this.invoiceline_description);
                data.append('price_exc_vat', this.invoiceline_price_exc_vat);
                data.append('no_vat', this.no_vat);
                data.append('type', this.selectedPaymentMethod?.value);

                axios.post( route('api.movements.invoices.lines.store'), data )
                    .then( response => {

                        this.invoice_lines.push(response.data[0]);

                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            icon: 'success',
                            title: 'Invoice Line Added',
                            showConfirmButton: false,
                            timer: 1500
                        });

                        this.selectedPaymentMethod = {};
                        this.invoiceline_description = '';
                        this.invoiceline_price_exc_vat = '';


                    })
                    .catch( error => {
                        console.error(error);
                    });

            },

            generateCalculateFuelCostUrl( fuel ) {
                return route('api.movements.expenses.calculate_fuel_cost', { litres: fuel });
            },

            calculateFuelCost( fuel ) {

                return axios.post( this.generateCalculateFuelCostUrl( fuel ) )
                    .then(response => {
                        return response.data;
                    })
                    .catch(error => {
                        console.error(error);
                    });

            },

            async generateFuelCosts() {
                for (const expense of this.compExpenses) {
                    if (expense.fuel > 0) {
                        try {
                            this.expenseCosts[expense.id] = await this.calculateFuelCost(expense.fuel);
                        } catch (error) {
                            console.error(`Error calculating fuel cost for expense ${expense.id}:`, error);
                            this.expenseCosts[expense.id] = { error: 'Failed to calculate' };
                        }
                    }
                }
            },

            deleteInvoiceLine( lineId ) {
                axios.delete( route('api.movements.invoices.lines.destroy', { line: lineId } ) )
                    .then( response => {
                        this.invoice_lines = this.invoice_lines.filter( line => line.id !== lineId );

                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            icon: 'success',
                            title: 'Invoice Line Removed',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    })
                    .catch( error => {
                        console.error(error);
                    });
            }

        },

        async mounted() {
            await this.generateFuelCosts();
        },

        data() {
            return {
                internalMovements: this.movements,
                selectedPaymentMethod: '',
                invoiceline_description: '',
                invoiceline_price_exc_vat: '',
                no_vat: false,
                expenseCosts: {},
                invoice_lines: this.job?.invoice_lines ?? null,
            }
        },


        computed: {
            /**
             * The title reads "Purchase Order: " with nothing after it when the
             * job has none, which looks like a rendering fault rather than the
             * very state the notice above is about.
             */
            purchaseOrderLabel() {
                return (this.job?.client_ref ?? '').trim() || 'not supplied';
            },

            /**
             * Read through the contract rather than job.customer, matching
             * Job::requiresPurchaseOrder() — the requirement being announced and
             * the name announcing it should come from the same record.
             */
            customerName() {
                return this.job?.contract?.customer?.name ?? 'This customer';
            },

            compSortedMovements() {
                const movementsArray = Array.isArray(this.internalMovements) ? this.internalMovements : Object.values(this.internalMovements);
                return movementsArray.sort((a, b) => a.position - b.position);
            },

            compExpenses() {
                return this.compSortedMovements.flatMap(movement =>
                    movement.expenses.filter(expense => expense.recharge_client)
                );
            },

        }

    }

</script>
